import { cx } from 'class-variance-authority';

export const dialogOverlay = cx(
  'fixed inset-0 z-50 flex items-center justify-center overflow-auto bg-neutral-900/50',
);

export const dialogContent = cx(
  'flex flex-col items-center gap-1 font-urbanist bg-white p-4 mt-4 size-fit  max-w-md justify-center rounded-xl text-center',
);

export const dialogTitle = cx('text-headline-4 font-semibold text-neutral-900 mb-3');

export const dialogDescription = cx('text-body text-neutral-500');
